/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_2_TitleInputs */

const da_forside_step_2_title = /** @type {(inputs: Forside_Step_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload besvarelserne`)
};

/** @type {(inputs: Forside_Step_2_TitleInputs) => LocalizedString} */
const en_forside_step_2_title = da_forside_step_2_title;

/**

* @param {Forside_Step_2_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_2_title = /** @type {((inputs?: Forside_Step_2_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_2_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_2_title(inputs)
	return /** @type {LocalizedString} */ ("Upload besvarelserne")
});